import React from 'react'
import { Route, Switch } from 'react-router-dom'

import asyncComponent from '../util/asyncComponent'

const App = ({ match }) => (
  <div className=''>
    <Switch>
      {/* Shared and unique routes merged below */}
      <Route
        exact
        path={`${match.url}/`}
        component={asyncComponent(() => import('./Home'))}
      />
      <Route
        path={`${match.url}home`}
        component={asyncComponent(() => import('./Home'))}
      />

      {/* Candidates */}
      <Route
        path={`${match.url}company/candidates`}
        component={asyncComponent(() => import('./Candidates'))}
      />
      <Route
        path={`${match.url}company/candidate-import-wizard`}
        component={asyncComponent(() =>
          import('./CandidateSetup/CandidateImportWizard')
        )}
      />
      <Route
        path={`${match.url}company/new-candidate`}
        component={asyncComponent(() =>
          import('./CandidateSetup/NewCandidate')
        )}
      />
      <Route
        path={`${match.url}company/candidate/profile/:slug`}
        component={asyncComponent(() => import('./CandidateProfile'))}
      />

        <Route
            path={`${match.url}company/employee-approval`}
            component={asyncComponent(() => import('./EmployeeApprovals'))}
        />

      {/* Document Types */}
      <Route
        path={`${match.url}company/document-types`}
        component={asyncComponent(() => import('./DocumentTypes'))}
      />

      {/* Documents */}
      <Route
        path={`${match.url}company/documents`}
        component={asyncComponent(() => import('./Documents'))}
      />

      {/* Announcements */}
      <Route
        path={`${match.url}company/announcements`}
        component={asyncComponent(() => import('./CompanyAnnouncements'))}
      />
      <Route
        path={`${match.url}company/announcement/add`}
        component={asyncComponent(() =>
          import('./CompanyAnnouncements/AddAnnouncement')
        )}
      />
      <Route
        path={`${match.url}company/announcement/modify/:slug`}
        component={asyncComponent(() =>
          import('./CompanyAnnouncements/ModifyAnnouncement')
        )}
      />

      {/* Notifications */}
      <Route
        path={`${match.url}company/notifications`}
        component={asyncComponent(() => import('./Notifications'))}
      />

      {/* Business Processes */}
      <Route
        path={`${match.url}company/business-processes/new`}
        component={asyncComponent(() => import('./BusinessProcess/NewBusinessProcess'))}
      />
      <Route
        path={`${match.url}company/business-processes/:id/edit`}
        component={asyncComponent(() => import('./BusinessProcess/EditBusinessProcess'))}
      />
      <Route
        path={`${match.url}company/business-processes/my-processes`}
        component={asyncComponent(() => import('./BusinessProcess/MyProcesses'))}
      />
      {/* Must come before the generic /:id route below, or ":id" greedily
          matches the literal "instances" segment and the real instance id
          is lost - same reason /new, /:id/edit and /my-processes are
          declared ahead of it too. */}
      <Route
        path={`${match.url}company/business-processes/instances/:id`}
        component={asyncComponent(() => import('./BusinessProcess/InstanceDetail'))}
      />
      <Route
        path={`${match.url}company/business-processes/:id`}
        component={asyncComponent(() => import('./BusinessProcess/BusinessProcessDetail'))}
      />
      <Route
        path={`${match.url}company/business-processes`}
        component={asyncComponent(() => import('./BusinessProcess'))}
      />

      {/* Company Tasks */}
      <Route
        exact
        path={`${match.url}company/company-tasks/new`}
        component={asyncComponent(() => import('./CompanyTasks/NewCompanyTask'))}
      />
      <Route
        exact
        path={`${match.url}company/company-tasks/:taskId/edit`}
        component={asyncComponent(() => import('./CompanyTasks/EditCompanyTask'))}
      />
      <Route
        exact
        path={`${match.url}company/company-tasks/instances/:instanceId`}
        component={asyncComponent(() => import('./CompanyTasks/InstanceDetail'))}
      />
      <Route
        path={`${match.url}company/company-tasks`}
        component={asyncComponent(() => import('./CompanyTasks'))}
      />

      <Route
        path={`${match.url}company/employee-notifications`}
        component={asyncComponent(() => import('./EmployeeNotification'))}
      />
      <Route
        path={`${match.url}company/company-holidays`}
        component={asyncComponent(() => import('./CompanyHoliday'))}
      />

      {/* Events */}
      <Route
        path={`${match.url}company/events`}
        component={asyncComponent(() => import('./Events'))}
      />
      <Route
        path={`${match.url}company/event-reports`}
        component={asyncComponent(() => import('./Events/EventAnalytics'))}
      />

      {/* Performance */}
      <Route path={`${match.url}performance/appraisals`} component={asyncComponent(() => import('./Appraisals'))} />
      <Route path={`${match.url}performance/my-appraisals`} component={asyncComponent(() => import('./MyAppraisals'))} />
      <Route path={`${match.url}performance/my-kpis`} component={asyncComponent(() => import('./MyKpis'))} />
      <Route path={`${match.url}performance/goals/view/:slug`} component={asyncComponent(() => import('./PerformanceGoals/ViewGoal'))} />
      <Route path={`${match.url}performance/goals`} component={asyncComponent(() => import('./PerformanceGoals'))} />
      <Route path={`${match.url}performance/reports`} component={asyncComponent(() => import('./PerformanceReports'))} />
      <Route path={`${match.url}performance/targets/details/:id`} component={asyncComponent(() => import('./PerformanceTargets/TargetDetails'))} />
      <Route path={`${match.url}performance/targets`} component={asyncComponent(() => import('./PerformanceTargets'))} />
      <Route path={`${match.url}performance/performance-center`} component={asyncComponent(() => import('./PerformanceManagement'))} />
      <Route path={`${match.url}performance/okrs/view/:slug`} component={asyncComponent(() => import('./PerformanceOkrs/ViewOkr'))} />
      <Route path={`${match.url}performance/okrs`} component={asyncComponent(() => import('./PerformanceOkrs'))} />
      <Route path={`${match.url}performance/settings`} component={asyncComponent(() => import('./PerformanceSettings'))} />
      <Route path={`${match.url}performance/appraisal-setup`} component={asyncComponent(() => import('./Appraisals/AppraisalSetup'))} />
      <Route path={`${match.url}appraisals/details/:slug`} component={asyncComponent(() => import('./AppraisalDetails'))} />
      <Route path={`${match.url}appraisals/report/:slug`} component={asyncComponent(() => import('./AppraisalDetails/AppraisalReportPage'))} />
      <Route path={`${match.url}appraisals/peer-report/:slug`} component={asyncComponent(() => import('./AppraisalDetails/PeerAppraisalReportPage'))} />
      <Route path={`${match.url}appraisals/edit/:slug`} component={asyncComponent(() => import('./Appraisals/ModifyAppraisal'))} />
      <Route path={`${match.url}appraisals/:slug/:user_id`} component={asyncComponent(() => import('./AppraisalDetails/AppraisalSubmissions'))} />
      <Route path={`${match.url}appraisal-single/:slug/:userId`} component={asyncComponent(() => import('./AppraisalSingle'))} />
      <Route path={`${match.url}performance/projects`} component={asyncComponent(() => import('./ProjectManagement/index-bloom'))} />
      <Route path={`${match.url}performance/competencies`} component={asyncComponent(() => import('./PerformanceCompetencies'))} />
      <Route path={`${match.url}performance/employees`} component={asyncComponent(() => import('./PerformanceEmployees'))} />
      <Route path={`${match.url}performance/rewards`} component={asyncComponent(() => import('./PerformanceRewards'))} />
      <Route path={`${match.url}performance/deliverables`} component={asyncComponent(() => import('./Deliverables'))} />
      <Route path={`${match.url}performance/appraisal-templates`} component={asyncComponent(() => import('./Appraisals/AppraisalTemplateClonePage'))} />

      {/* Comprehensive Appraisals */}
      <Route path={`${match.url}performance/comprehensive/new`} component={asyncComponent(() => import('./ComprehensiveAppraisals/NewComprehensive'))} />
      <Route path={`${match.url}performance/comprehensive/:id/edit`} component={asyncComponent(() => import('./ComprehensiveAppraisals/NewComprehensive'))} />
      <Route path={`${match.url}performance/comprehensive/:id/dashboard`} component={asyncComponent(() => import('./ComprehensiveAppraisals/ComprehensiveDashboard'))} />
      <Route path={`${match.url}performance/comprehensive/:id/report`} component={asyncComponent(() => import('./ComprehensiveAppraisals/ComprehensiveAppraisalReport'))} />
      <Route path={`${match.url}performance/comprehensive/:id/preview`} component={asyncComponent(() => import('./ComprehensiveAppraisals/PreviewComprehensive'))} />


      {/* Company Setup */}
      <Route
        path={`${match.url}company/departments`}
        component={asyncComponent(() => import('./Departments'))}
      />
      <Route
        path={`${match.url}company/usergroups`}
        component={asyncComponent(() => import('./UserGroups'))}
      />
      <Route
        path={`${match.url}company/job-roles`}
        component={asyncComponent(() => import('./JobRoles'))}
      />
      <Route
        exact
        path={`${match.url}company/dynamic-forms/new`}
        component={asyncComponent(() => import('./DynamicForms/NewForm'))}
      />
      <Route
        exact
        path={`${match.url}company/dynamic-forms/:id/edit`}
        component={asyncComponent(() => import('./DynamicForms/NewForm'))}
      />
      <Route
        exact
        path={`${match.url}company/dynamic-forms/:id`}
        component={asyncComponent(() => import('./DynamicForms/View'))}
      />
      <Route
        exact
        path={`${match.url}company/dynamic-forms`}
        component={asyncComponent(() => import('./DynamicForms'))}
      />
      <Route
        exact
        path={`${match.url}company/workflows`}
        component={asyncComponent(() => import('./Workflow/DashboardPage'))}
      />
      <Route
        exact
        path={`${match.url}company/workflow/templates`}
        component={asyncComponent(() => import('./Workflow/WorkflowTemplates'))}
      />
      <Route
        exact
        path={`${match.url}company/workflow/templates/new`}
        component={asyncComponent(() => import('./Workflow/EditTemplatePage'))}
      />
      <Route
        exact
        path={`${match.url}company/workflow/templates/:id/edit`}
        component={asyncComponent(() => import('./Workflow/EditTemplatePage'))}
      />
      <Route
        exact
        path={`${match.url}company/workflow/requests`}
        component={asyncComponent(() => import('./Workflow/Requests'))}
        // component={asyncComponent(() => import('./Workflow/RequestsPage'))}
      />
      <Route
        exact
        path={`${match.url}company/workflow/requests/:id`}
        component={asyncComponent(() => import('./Workflow/RequestDetailPage'))}
      />
      <Route
        path={`${match.url}company/letters`}
        component={asyncComponent(() => import('./Letters'))}
      />
      <Route
        path={`${match.url}company/letter/new`}
        component={asyncComponent(() => import('./Letters/NewLetter'))}
      />
      <Route
        path={`${match.url}company/letter/edit/:slug`}
        component={asyncComponent(() => import('./Letters/UpdateLetter'))}
      />
      <Route
        path={`${match.url}company/letter/others`}
        component={asyncComponent(() => import('./Letters/NewTemplateOthers'))}
      />
      <Route
        path={`${match.url}company/letter/report-template`}
        component={asyncComponent(() => import('./Letters/NewReportTemplate'))}
      />
      <Route
        path={`${match.url}company/pay-grades`}
        component={asyncComponent(() => import('./OnBoardingTasks'))}
      />
      <Route
        path={`${match.url}company/onboarding-tasks`}
        component={asyncComponent(() => import('./OnBoardingTasks'))}
      />
      <Route
        path={`${match.url}company/onboarding-feedback`}
        component={asyncComponent(() => import('./Feedback'))}
      />
      <Route
        path={`${match.url}company/pay-structures`}
        component={asyncComponent(() => import('./PayStructure'))}
      />
      <Route
        path={`${match.url}company/rates`}
        component={asyncComponent(() => import('./CompanyRates'))}
      />
      <Route
        path={`${match.url}company/branches`}
        component={asyncComponent(() => import('./Branches'))}
      />


      {/* Validation */}
      <Route
        path={`${match.url}employee-validations/:id`}
        component={asyncComponent(() => import('./EmployeeValidations'))}
      />
      <Route
        path={`${match.url}employee-validation-approval/:id?`}
        component={asyncComponent(() => import('./EmployeeSalaryApproval'))}
      />
      <Route
        path={`${match.url}company/validations`}
        component={asyncComponent(() => import('./CompanyValidations'))}
      />

      {/* Help Desk */}
      <Route
        path={`${match.url}company/helpdesk`}
        component={asyncComponent(() => import('./HelpDesk'))}
      />

      {/* Employee - Attendance */}
      <Route
        path={`${match.url}employee/appraisal-documents`}
        component={asyncComponent(() => import('./AppraisalDocuments'))}
      /> 
      <Route
        path={`${match.url}employee/attendance`}
        component={asyncComponent(() => import('./Attendance'))}
      />
      <Route
        path={`${match.url}employee/report_attendance`}
        component={asyncComponent(() => import('./AttendanceReport'))}
      />
      <Route
        path={`${match.url}attendance/regularization`}
        component={asyncComponent(() => import('./RegularizationRequest'))}
      />
      <Route
        path={`${match.url}attendance/reports`}
        component={asyncComponent(() => import('./AttendanceReport'))}
      />
      {/* <Route
        path={`${match.url}attendance/totalhours`}
        component={asyncComponent(() => import('./AttendanceHours'))}
      /> */}
      <Route
        path={`${match.url}attendance/daily_attendance_status`}
        component={asyncComponent(() => import('./Attendance/DailyAttendance'))}
      />

      {/* Employee Center */}
      <Route
        path={`${match.url}employee/employee-center`}
        component={asyncComponent(() => import('./EmployeeCenter'))}
      />
      <Route
        path={`${match.url}employee/employee-verifications`}
        component={asyncComponent(() => import('./EmployeeVerifications'))}
      />
      <Route
        path={`${match.url}employee/employee-rates`}
        component={asyncComponent(() => import('./EmployeePayRates'))}
      />
      <Route
        path={`${match.url}employee/employee-files`}
        component={asyncComponent(() => import('./EmployeeFiles'))}
      />
      <Route
        path={`${match.url}employee/salary-advances`}
        component={asyncComponent(() => import('./SalaryAdvances'))}
      />
      <Route
        path={`${match.url}employee/covid-vaccinations`}
        component={asyncComponent(() => import('./CovidVaccinations'))}
      />
      <Route
        path={`${match.url}employee/supervisors`}
        component={asyncComponent(() => import('./Supervisors'))}
      />
      <Route
        path={`${match.url}supervisor/employeevalidation`}
        component={asyncComponent(() =>
          import('./Supervisor_EmployeeValidation')
        )}
      />
      <Route
        path={`${match.url}employeevalidation/reports`}
        component={asyncComponent(() => import('./EmployeeValidationReport'))}
      />
      <Route
        path={`${match.url}employeevalidation/report/:userid`}
        component={asyncComponent(() => import('./ViewEmployeesReports'))}
      />
      <Route
        path={`${match.url}employee/document-status`}
        component={asyncComponent(() => import('./DocumentStatus'))}
      />
      <Route
        path={`${match.url}employee/new-employee`}
        component={asyncComponent(() => import('./EmployeeSetup/NewEmployee'))}
      />
      <Route
        path={`${match.url}employee/modify/:slug`}
        component={asyncComponent(() => import('./EmployeeModification'))}
      />
      <Route
        path={`${match.url}employee/employee-import-wizard`}
        component={asyncComponent(() =>
          import('./EmployeeSetup/EmployeeImportWizard')
        )}
      />
      <Route
        path={`${match.url}employee/employee-variations`}
        component={asyncComponent(() => import('./EmployeeVariations'))}
      />
      <Route
        path={`${match.url}employee/variation-wizard`}
        component={asyncComponent(() => import('./EmployeeVariationWizard'))}
      />
      <Route
        path={`${match.url}employee/training-schedules`}
        component={asyncComponent(() => import('./TrainingSchedules'))}
      />
      <Route
        path={`${match.url}employee/exits`}
        component={asyncComponent(() => import('./EmployeeExits'))}
      />
      <Route
        path={`${match.url}employee/learners`}
        component={asyncComponent(() => import('./GrpLearners'))}
      />

      {/* Issues */}
      <Route
        path={`${match.url}issues/confidential-notes`}
        component={asyncComponent(() => import('./ConfidentialNotes'))}
      />
      <Route
        path={`${match.url}issues/cases`}
        component={asyncComponent(() => import('./CompanyCases'))}
      />
      <Route
        path={`${match.url}issues/blacklist`}
        component={asyncComponent(() => import('./EmployeeBlackList'))}
      />
      <Route
        path={`${match.url}issues/employee-queries`}
        component={asyncComponent(() => import('./EmployeeQueries'))}
      />
      <Route
        path={`${match.url}issues/query/add`}
        component={asyncComponent(() =>
          import('./EmployeeQueries/AddEmployeeQuery')
        )}
      />
      <Route
        path={`${match.url}issues/modify/:slug`}
        component={asyncComponent(() =>
          import('./EmployeeQueries/ModifyEmployeeQuery')
        )}
      />
      <Route
        path={`${match.url}issues/view/:slug`}
        component={asyncComponent(() =>
          import('./EmployeeQueries/ModifyEmployeeQuery')
        )}
      />

      {/* Profile Verification */}
      <Route
        path={`${match.url}employee/profile-verifications`}
        component={asyncComponent(() => import('./ProfileVerifications'))}
      />

      {/* Leave */}
      <Route
        path={`${match.url}leave-tracker/leave`}
        component={asyncComponent(() => import('./Leave'))}
      />
      <Route
        path={`${match.url}leave-tracker/leave-applications`}
        component={asyncComponent(() => import('./LeaveApplications'))}
      />
      <Route
        path={`${match.url}leave-tracker/leave-applications-others`}
        component={asyncComponent(() => import('./LeaveApplicationOthers'))}
      />
      <Route
        path={`${match.url}leave-tracker/leave-resumption`}
        component={asyncComponent(() => import('./LeaveResumption'))}
      />
      <Route
        path={`${match.url}leave-tracker/leave-insights`}
        component={asyncComponent(() => import('./LeaveInsights'))}
      />

      {/* Payroll */}
      <Route
        path={`${match.url}payroll/employee-exclusions/:payrollId`}
        component={asyncComponent(() => import('./EmployeeExclusions'))}
      />
      <Route
        path={`${match.url}payroll/deleted-earnings/:payrollId`}
        component={asyncComponent(() => import('./DeletedEarnings'))}
      />
      <Route
        path={`${match.url}payroll/payroll-center`}
        component={asyncComponent(() => import('./PayrollCenter'))}
      />
      <Route
        path={`${match.url}payroll/payroll-register/:id`}
        component={asyncComponent(() =>
          import('./PayrollCenter/PayrollRegister')
        )}
      />

      {/* Voting */}
      <Route
        path={`${match.url}voting/polls`}
        component={asyncComponent(() => import('./Polls'))}
      />
      <Route
        path={`${match.url}voting/voters-group`}
        component={asyncComponent(() => import('./VotersGroup'))}
      />
      <Route
        path={`${match.url}voting/votes`}
        component={asyncComponent(() => import('./VotesResults'))}
      />

      <Route path={`${match.url}knowledge`} component={asyncComponent(() => import('./KnowledgeBase'))}/>

      <Route
        path={`${match.url}company/documentation/new`}
        component={asyncComponent(() => import('./Documentation/DocTypeSelector'))}
      />
      <Route
        path={`${match.url}company/documentation/create/article`}
        component={asyncComponent(() => import('./Documentation/wizards/ArticleWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/create/video`}
        component={asyncComponent(() => import('./Documentation/wizards/VideoWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/create/screen_recording`}
        component={asyncComponent(() => import('./Documentation/wizards/ScreenRecordingWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/create/embed`}
        component={asyncComponent(() => import('./Documentation/wizards/EmbedWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/create/steps`}
        component={asyncComponent(() => import('./Documentation/wizards/StepsWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/create/html`}
        component={asyncComponent(() => import('./Documentation/wizards/HtmlWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/create/external_link`}
        component={asyncComponent(() => import('./Documentation/wizards/LinkWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/create/pdf`}
        component={asyncComponent(() => import('./Documentation/wizards/LinkWizard'))}
      />
      <Route
        path={`${match.url}company/documentation/edit/:id`}
        component={asyncComponent(() => import('./Documentation/DocEditRouter'))}
      />
      <Route
        path={`${match.url}company/documentation`}
        component={asyncComponent(() => import('./Documentation'))}
      />

      <Route
        path={`${match.url}employee/transition`}
        component={asyncComponent(() => import('./Promotion'))}
      />
      <Route
        path={`${match.url}company/alumni`}
        component={asyncComponent(() => import('./CompanyAlumni'))}
      />
    </Switch>
  </div>
)

export default App
